import React, { useState } from 'react';
import './MarketsPage.css';

const MarketsPage = ({ t }) => {
  const [activeTab, setActiveTab] = useState('forex');
  const [selectedInstrument, setSelectedInstrument] = useState('EURUSD');

  // Market data
  const marketData = {
    forex: [
      { symbol: 'EURUSD', name: 'Euro / US Dollar', price: '1.0854', change: '+0.15%', changeValue: '+0.0016', high: '1.0862', low: '1.0838', volume: '125.4K' },
      { symbol: 'GBPUSD', name: 'British Pound / US Dollar', price: '1.2654', change: '-0.08%', changeValue: '-0.0010', high: '1.2668', low: '1.2642', volume: '98.7K' },
      { symbol: 'USDJPY', name: 'US Dollar / Japanese Yen', price: '148.25', change: '+0.22%', changeValue: '+0.32', high: '148.45', low: '147.98', volume: '156.2K' },
      { symbol: 'USDCHF', name: 'US Dollar / Swiss Franc', price: '0.8542', change: '-0.12%', changeValue: '-0.0010', high: '0.8555', low: '0.8530', volume: '67.3K' },
      { symbol: 'AUDUSD', name: 'Australian Dollar / US Dollar', price: '0.6548', change: '+0.18%', changeValue: '+0.0012', high: '0.6555', low: '0.6532', volume: '89.1K' },
      { symbol: 'USDCAD', name: 'US Dollar / Canadian Dollar', price: '1.3542', change: '-0.05%', changeValue: '-0.0007', high: '1.3550', low: '1.3535', volume: '73.8K' }
    ],
    stocks: [
      { symbol: 'AAPL', name: 'Apple Inc.', price: '185.64', change: '+1.25%', changeValue: '+2.30', high: '186.20', low: '183.45', volume: '45.2M' },
      { symbol: 'MSFT', name: 'Microsoft Corporation', price: '378.85', change: '+0.89%', changeValue: '+3.35', high: '379.50', low: '375.20', volume: '28.7M' },
      { symbol: 'GOOGL', name: 'Alphabet Inc.', price: '142.56', change: '-0.45%', changeValue: '-0.65', high: '143.20', low: '141.80', volume: '32.1M' },
      { symbol: 'AMZN', name: 'Amazon.com Inc.', price: '145.24', change: '+0.78%', changeValue: '+1.12', high: '145.80', low: '144.10', volume: '38.9M' },
      { symbol: 'TSLA', name: 'Tesla Inc.', price: '248.42', change: '+2.15%', changeValue: '+5.23', high: '249.50', low: '243.80', volume: '52.3M' },
      { symbol: 'META', name: 'Meta Platforms Inc.', price: '334.69', change: '+0.92%', changeValue: '+3.05', high: '335.20', low: '331.50', volume: '25.6M' }
    ],
    commodities: [
      { symbol: 'XAUUSD', name: 'Gold / US Dollar', price: '2,045.60', change: '+0.35%', changeValue: '+7.15', high: '2,048.20', low: '2,038.50', volume: '12.4K' },
      { symbol: 'XAGUSD', name: 'Silver / US Dollar', price: '23.45', change: '+0.28%', changeValue: '+0.065', high: '23.52', low: '23.38', volume: '8.9K' },
      { symbol: 'WTIUSD', name: 'Crude Oil WTI', price: '78.45', change: '-1.25%', changeValue: '-0.99', high: '79.20', low: '78.10', volume: '156.7K' },
      { symbol: 'BRENTUSD', name: 'Brent Crude Oil', price: '82.30', change: '-1.15%', changeValue: '-0.96', high: '83.10', low: '82.05', volume: '134.2K' },
      { symbol: 'NATGAS', name: 'Natural Gas', price: '2.85', change: '+2.15%', changeValue: '+0.06', high: '2.88', low: '2.79', volume: '89.3K' },
      { symbol: 'COPPER', name: 'Copper', price: '3.85', change: '+0.45%', changeValue: '+0.017', high: '3.87', low: '3.83', volume: '45.6K' }
    ],
    indices: [
      { symbol: 'SPX500', name: 'S&P 500', price: '4,567.89', change: '+0.45%', changeValue: '+20.45', high: '4,572.30', low: '4,550.20', volume: '2.1B' },
      { symbol: 'NAS100', name: 'NASDAQ 100', price: '15,678.45', change: '+0.78%', changeValue: '+121.35', high: '15,690.20', low: '15,650.80', volume: '1.8B' },
      { symbol: 'US30', name: 'Dow Jones 30', price: '37,245.67', change: '+0.25%', changeValue: '+92.15', high: '37,280.50', low: '37,200.30', volume: '890M' },
      { symbol: 'GER30', name: 'DAX 30', price: '16,789.34', change: '+0.35%', changeValue: '+58.45', high: '16,800.20', low: '16,750.60', volume: '456M' },
      { symbol: 'UK100', name: 'FTSE 100', price: '7,456.78', change: '-0.15%', changeValue: '-11.23', high: '7,470.50', low: '7,440.20', volume: '234M' },
      { symbol: 'JPN225', name: 'Nikkei 225', price: '33,456.78', change: '+0.65%', changeValue: '+215.45', high: '33,500.20', low: '33,400.60', volume: '567M' }
    ],
    crypto: [
      { symbol: 'BTCUSD', name: 'Bitcoin / US Dollar', price: '43,567.89', change: '+2.45%', changeValue: '+1,042.35', high: '43,800.20', low: '42,500.60', volume: '28.9B' },
      { symbol: 'ETHUSD', name: 'Ethereum / US Dollar', price: '2,456.78', change: '+1.85%', changeValue: '+44.56', high: '2,470.50', low: '2,420.30', volume: '15.6B' },
      { symbol: 'BNBUSD', name: 'Binance Coin / US Dollar', price: '312.45', change: '+0.95%', changeValue: '+2.94', high: '314.20', low: '309.80', volume: '2.3B' },
      { symbol: 'ADAUSD', name: 'Cardano / US Dollar', price: '0.4856', change: '+1.25%', changeValue: '+0.0060', high: '0.4880', low: '0.4790', volume: '890M' },
      { symbol: 'SOLUSD', name: 'Solana / US Dollar', price: '98.45', change: '+3.15%', changeValue: '+3.01', high: '99.20', low: '95.80', volume: '3.2B' },
      { symbol: 'DOTUSD', name: 'Polkadot / US Dollar', price: '7.23', change: '+0.75%', changeValue: '+0.054', high: '7.28', low: '7.18', volume: '456M' }
    ]
  };

  const tabs = [
    { id: 'forex', name: t.forex, icon: 'currency_exchange' },
    { id: 'stocks', name: t.stocks, icon: 'trending_up' },
    { id: 'commodities', name: t.commodities, icon: 'inventory' },
    { id: 'indices', name: t.indices, icon: 'bar_chart' },
    { id: 'crypto', name: t.crypto, icon: 'currency_bitcoin' }
  ];

  const timeframes = ['1m', '5m', '15m', '1h', '4h', '1d', '1w', '1M'];

  return (
    <div className="markets-page">
      <div className="markets-header">
        <div className="container">
          <h1>{t.livePrices}</h1>
          <p>Real-time market data and trading charts</p>
        </div>
      </div>

      <div className="markets-content">
        <div className="container">
          <div className="markets-layout">
            {/* Left Sidebar - Market Instruments */}
            <div className="markets-sidebar">
              <div className="market-tabs">
                {tabs.map(tab => (
                  <button
                    key={tab.id}
                    className={`market-tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <span className="material-icons">{tab.icon}</span>
                    {tab.name}
                  </button>
                ))}
              </div>

              <div className="instruments-list">
                <div className="instruments-header">
                  <h3>{tabs.find(tab => tab.id === activeTab)?.name}</h3>
                  <div className="search-instruments">
                    <span className="material-icons">search</span>
                    <input type="text" placeholder="Search instruments..." />
                  </div>
                </div>

                <div className="instruments-table">
                  <div className="table-header">
                    <span>Symbol</span>
                    <span>Price</span>
                    <span>{t.change}</span>
                  </div>
                  {marketData[activeTab].map((instrument, index) => (
                    <div
                      key={instrument.symbol}
                      className={`instrument-row ${selectedInstrument === instrument.symbol ? 'selected' : ''}`}
                      onClick={() => setSelectedInstrument(instrument.symbol)}
                    >
                      <div className="instrument-symbol">
                        <span className="symbol">{instrument.symbol}</span>
                        <span className="name">{instrument.name}</span>
                      </div>
                      <div className="instrument-price">{instrument.price}</div>
                      <div className={`instrument-change ${instrument.change.startsWith('+') ? 'positive' : 'negative'}`}>
                        {instrument.change}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Side - Chart and Details */}
            <div className="markets-main">
              <div className="chart-section">
                <div className="chart-header">
                  <div className="selected-instrument">
                    <h2>{selectedInstrument}</h2>
                    <p>{marketData[activeTab].find(item => item.symbol === selectedInstrument)?.name}</p>
                  </div>
                  <div className="chart-controls">
                    <div className="timeframe-buttons">
                      {timeframes.map(tf => (
                        <button key={tf} className="timeframe-btn">{tf}</button>
                      ))}
                    </div>
                    <div className="chart-actions">
                      <button className="chart-btn">
                        <span className="material-icons">fullscreen</span>
                      </button>
                      <button className="chart-btn">
                        <span className="material-icons">settings</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="chart-container">
                  <div className="chart-placeholder">
                    <div className="chart-mock">
                      <div className="chart-line"></div>
                      <div className="chart-candles">
                        {[...Array(20)].map((_, i) => (
                          <div key={i} className="candle" style={{
                            height: `${Math.random() * 60 + 20}px`,
                            backgroundColor: Math.random() > 0.5 ? '#4CAF50' : '#F44336'
                          }}></div>
                        ))}
                      </div>
                    </div>
                    <div className="chart-overlay">
                      <span className="material-icons">show_chart</span>
                      <p>Interactive Trading Chart</p>
                      <small>Real-time price movements and technical analysis</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="instrument-details">
                <div className="details-grid">
                  <div className="detail-card">
                    <div className="detail-header">
                      <span className="material-icons">trending_up</span>
                      <h4>Price Information</h4>
                    </div>
                    <div className="detail-content">
                      {(() => {
                        const instrument = marketData[activeTab].find(item => item.symbol === selectedInstrument);
                        return (
                          <>
                            <div className="detail-row">
                              <span>{t.open}</span>
                              <span>{instrument.price}</span>
                            </div>
                            <div className="detail-row">
                              <span>{t.high}</span>
                              <span>{instrument.high}</span>
                            </div>
                            <div className="detail-row">
                              <span>{t.low}</span>
                              <span>{instrument.low}</span>
                            </div>
                            <div className="detail-row">
                              <span>{t.volume}</span>
                              <span>{instrument.volume}</span>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>

                  <div className="detail-card">
                    <div className="detail-header">
                      <span className="material-icons">account_balance</span>
                      <h4>Trading</h4>
                    </div>
                    <div className="detail-content">
                      <div className="trading-buttons">
                        <button className="btn-buy">
                          <span className="material-icons">trending_up</span>
                          {t.buy}
                        </button>
                        <button className="btn-sell">
                          <span className="material-icons">trending_down</span>
                          {t.sell}
                        </button>
                      </div>
                      <div className="spread-info">
                        <span>Spread: 0.1 pips</span>
                        <span>Leverage: 1:500</span>
                      </div>
                    </div>
                  </div>

                  <div className="detail-card">
                    <div className="detail-header">
                      <span className="material-icons">article</span>
                      <h4>{t.news}</h4>
                    </div>
                    <div className="detail-content">
                      <div className="news-item">
                        <h5>Market Analysis: {selectedInstrument} Technical Outlook</h5>
                        <p>Latest technical analysis and market sentiment for {selectedInstrument}...</p>
                        <span className="news-time">2 hours ago</span>
                      </div>
                      <div className="news-item">
                        <h5>Economic Calendar Impact</h5>
                        <p>Upcoming economic events that may affect {selectedInstrument} price movements...</p>
                        <span className="news-time">4 hours ago</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketsPage;
